import { DISABLE_AUTOMATIC_WRAPPING, WidgetComponent } from "../widget.component";
import { EditableWidget, WIDGET_SPOTIFY } from "@shared/models/widget";
import { Component, ChangeDetectionStrategy } from "@angular/core";
import { TranslateService, TranslatePipe } from "@ngx-translate/core";
import { LogService } from "@shared/services/log.service";
import { ConfigScreenWidgetComponent } from "../config-screen/config-screen.widget.component";
import { FieldComponent } from "../../../elements/field/field.component";

@Component({
    templateUrl: "spotify.widget.component.html",
    styleUrls: ["spotify.widget.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [ConfigScreenWidgetComponent, FieldComponent, TranslatePipe]
})
export class SpotifyWidgetConfigComponent extends WidgetComponent {

    constructor(public translate: TranslateService, logService: LogService) {
        super(WIDGET_SPOTIFY, "Spotify", translate, logService, DISABLE_AUTOMATIC_WRAPPING, "spotify");
    }

    protected OnNewWidgetPrepared(widget: EditableWidget): void {
        widget.dimension.newData.uri = "";
    }

    protected OnWidgetBeforeAdd(widget: EditableWidget): void {
        this.setSpotifyUrl(widget);
    }

    protected OnWidgetBeforeEdit(widget: EditableWidget) {
        this.setSpotifyUrl(widget);
    }

    private setSpotifyUrl(widget: EditableWidget) {
        widget.dimension.newUrl = window.location.origin + "/widgets/spotify?uri=$uri";
    }
}
